import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ReloadIcon } from "@radix-ui/react-icons";
import React, { useEffect, useMemo, useState } from "react";
import debounce from "lodash.debounce";

interface DataTableToolbarProps {
  onFilterChange: (text: string) => void;
  onRefresh: () => void;
}

export const DataTableToolbar = (props: DataTableToolbarProps) => {
  const [filterValue, setFilterValue] = useState("");

  const debounced = useMemo(() => debounce(props.onFilterChange, 300), []);

  useEffect(() => {
    return () => {
      debounced.cancel();
    };
  }, []);

  const handleFilterValueChange: React.ChangeEventHandler<HTMLInputElement> = (
    e
  ) => {
    setFilterValue(e.target.value);
    debounced(e.target.value);
  };

  return (
    <div className="flex items-center justify-between">
      <div>
        <Input
          placeholder="Filter by mobile or UID"
          value={filterValue}
          onChange={handleFilterValueChange}
          className="h-8 w-[200px] lg:w-[250px]"
        />
      </div>
      <div>
        <Button
          variant="outline"
          onClick={props.onRefresh}
          className="h-8 px-2 lg:px-3"
        >
          Refresh
          <ReloadIcon className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
